import { useRouteMatch } from 'react-router-dom'

import { PROTECTED_PATH_PREFIX } from 'utils/apiPath'

/**
 * Whether the activity was opened from a bot-protected distribution link.
 *
 * Derived from the router rather than `window.location` so it cannot drift from
 * the URL after a `history.push` (locale changes push a new path mid-activity).
 */
export function useIsProtectedRoute(): boolean {
  return !!useRouteMatch(PROTECTED_PATH_PREFIX)
}
